import init from "./common";
import { Tabs } from "./utils/tabs";
import { Fancybox } from "@fancyapps/ui";
import LazyLoad from "vanilla-lazyload";
import { ajaxArticles } from "./ajax/ajax-articles";
import { tns } from "tiny-slider/src/tiny-slider";

jQuery(function () {
  init();
  // Init Lazy load instance
  var lazyLoad = new LazyLoad();
  function sliderLazy() {
    lazyLoad.update();
  }

  var tabs_container = document.getElementById("tabs");
  if (tabs_container !== null) {
    const tabs = new Tabs({
      elem: "tabs",
      open: 0,
    });
  }

  if (jQuery(".archive__form")) {
    ajaxArticles();
  }
  // Init Galerie
  Fancybox.bind("[data-fancybox='galerie']", {
    // Your options go here
    thumbs: {
      autoStart: true,
    },
  });
  // Listes Depliables
  jQuery(".liste-depliable__title").on("click", function () {
    jQuery(this).toggleClass("active");
    jQuery(this).find(".fa-chevron-down").toggleClass("hidden");
    jQuery(this).find(".fa-chevron-up").toggleClass("hidden");
    jQuery(this).next(".liste-depliable__content").slideToggle();
  });

  // Init slider pour .slider-publications
  if (jQuery(".liste-actualites").length > 0) {
    var sliderActualites = tns({
      container: ".slider-actualites",
      items: 1,
      slideBy: "page",
      autoplay: false,
      nav: false,
      controls: true,

      controlsContainer: ".controls-slider-actualites",
      responsive: {
        0: {
          items: 1,
          gutter: 0,
        },
        900: {
          items: 2,
          gutter: 40,
        },
        1280: {
          items: 3,
          gutter: 50,
        },
      },
    });
    sliderActualites.events.on("indexChanged", sliderLazy);
  }
  if (jQuery(".liste-agenda").length > 0) {
    var sliderAgenda = tns({
      container: ".slider-agenda",
      slideBy: "page",
      autoplay: false,
      nav: false,
      controls: true,
      controlsContainer: ".controls-slider-agenda",
      responsive: {
        0: {
          items: 1,
          gutter: 0,
        },
        900: {
          items: 2,
          gutter: 40,
        },
        1280: {
          items: 3,
          gutter: 80,
        },
      },
    });
    sliderAgenda.events.on("indexChanged", sliderLazy);
  }

  // if there is a tag inside a table whith a .pdf link, execute get_filesize() function
  if (jQuery("table").length > 0) {
    jQuery("table a[href$='.pdf']").each(function () {
      // apppend icon <i class="fas folder-arrow-down"></i> before link
      jQuery(this).prepend('<i class="fas fa-folder-arrow-down"></i>');
      const id = jQuery(this).data("id");
      // filesize is async
      get_filesize(id, jQuery(this));
    });
  }
});

const get_filesize = (id, object) => {
  // ajax call
  jQuery.ajax({
    url: window.origin + "/wp/wp-admin/admin-ajax.php",
    data: {
      action: "get_filesize",
      id: id,
    },
    type: "POST",
    success: function (data) {
      // append data after object tag in a span
      jQuery(
        '<span class="filesize block">' + data.data + "</span>"
      ).insertAfter(object);
      console.log(data, object);
    },
  });
};
